import React from 'react';

import {Stack, Typography, Button} from 'views/components';
import {Translate} from 'views/module';
import {useNavigate} from 'react-router-dom';

const ProfileNotAvailable = () => {
  const navigate = useNavigate();

  const handleBackHome = () => {
    navigate('/caregivers');
  };

  return (
    <Stack width="100%" alignItems="center" sx={{bgcolor: '#FAF9F6', minHeight: '100vh'}}>
      <Stack
        spacing={{xs: 3, sm: 4, md: 5, lg: 6}}
        sx={{
          alignItems: 'center',
          maxWidth: {sm: '100%', md: 700, lg: 1000},
          m: 2,
          p: {xs: 3, sm: 4},
          width: '100%',
          bgcolor: '#FFFDFC',
          borderRadius: 4,
          border: '1px solid',
          borderColor: 'color.divider',
          boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
          boxSizing: 'border-box',
        }}
      >
        <Typography
          sx={{
            fontSize: {xs: 18, sm: 22, md: 26},
            color: '#686868',
            textAlign: 'center',
            mb: 2,
          }}
        >
          <Translate expression='caregiverDetail.ProfileNotAvailable.Title'/>
        </Typography>
        <Typography
          sx={{
            fontSize: {xs: 14, sm: 16, md: 18},
            color: '#686868',
            textAlign: 'center',
            maxWidth: 500,
            mb: 4,
          }}
        >
          <Translate expression="caregiverDetail.ProfileNotAvailable.Description"/>
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleBackHome}
          sx={{mt: 2}}
        >
          <Translate expression="caregiverDetail.ProfileNotAvailable.BackToCaregiverList"/>
        </Button>
      </Stack>
    </Stack>
  );
};

export default ProfileNotAvailable;
